'use client';

import type { LottieRefCurrentProps } from 'lottie-react';
import animationData from '@/animations/logo.json';
import { useInView } from 'motion/react';
import { useEffect, useRef } from 'react';
import { css } from '@onbeam/business-styled-system/css';
import dynamic from 'next/dynamic';

const Lottie = dynamic(() => import('lottie-react'), { ssr: false });

export const TokenSectionLogo = () => {
  const containerRef = useRef<HTMLDivElement>(null);
  const lottieRef = useRef<LottieRefCurrentProps>(null);
  const isInView = useInView(containerRef, {
    once: true,
    amount: 'all',
  });

  useEffect(() => {
    if (!lottieRef.current || !isInView) return;
    lottieRef.current.play();
  }, [isInView]);

  return (
    <div ref={containerRef} className={css({ w: '[2.5rem]', h: '[2.5rem]' })}>
      <Lottie
        lottieRef={lottieRef}
        animationData={animationData}
        autoplay={false}
        loop={false}
      />
    </div>
  );
};
